import { ERROR_COLOR, SUCCESS_COLOR } from '@constants/values';
import React from 'react';
import Text from '@amzn/meridian/text';

const diffCellStyleRenderer = (params: { value: number }) => {
  const cellStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
  };

  if (params.value > 0) {
    return (
      <div style={cellStyle}>
        <Text className={SUCCESS_COLOR}>{params.value}</Text>
      </div>
    );
  }
  if (params.value < 0) {
    return (
      <div style={cellStyle}>
        <Text className={ERROR_COLOR}>{params.value}</Text>
      </div>
    );
  }
  return (
    <div style={cellStyle}>
      <Text>{params.value}</Text>
    </div>
  );
};

export default diffCellStyleRenderer;
